import React, { Component } from "react";
import { Link } from "react-router-dom";
import LayoutWrapper from "../LayoutWrapper";
import schoolmanagementapi from "../../../../api/devapis/schoolmanagementapi";
import issuecategoryapi from "../../../../api/devapis/issuecategoryapi";
import { message, Select, DatePicker, Form, Button, Input } from "antd";
import { ISSUE_STATUS, ISSUE_STATUS_LABELS } from "../schoolinframaintenancetracker";

const { Option } = Select;
import "./editmaintenancequeue.scss";

export class EditMaintenanceQueue extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("SchoolInfraMaintenanceTracker");
    const issueId = this.getIssueIdFromUrl();
    const searchParams = new URLSearchParams(window.location.search);
    const mode = searchParams.get("mode") || "edit";

    this.state = {
      issueId,
      mode,
      loading: false,
      issueDetail: null,
      comment: "",
      submittingComment: false,
      timeline: [],
      initialAssignTo: "Unassigned",
      initialPriority: undefined,
      initialStatus: undefined,
      updateAssignTo: "Unassigned",
      updatePriority: undefined,
      updateEstimatedEndDate: null,
      updateStatus: undefined,
      users: [],
      loadingUsers: false,
      priorities: [],
      loadingPriorities: false,
      updatingIssue: false,
    };
  }

  getAuthHeaders = () => {
    let token =
      window.store?.getState()?.root?.auth ||
      localStorage.getItem("token") ||
      localStorage.getItem("auth") ||
      "";
    if (token) {
      token = token.trim();
      if (!token.toLowerCase().startsWith("bearer ")) {
        token = `Bearer ${token}`;
      }
      return {
        Authorization: token,
        "Content-Type": "application/json",
      };
    }
    return {
      "Content-Type": "application/json",
    };
  };

  getIssueIdFromUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return (
      searchParams.get("id") ||
      searchParams.get("issueId") ||
      searchParams.get("issue_id") ||
      searchParams.get("_id") ||
      this.props.urlparams?.id ||
      this.props.urlparams?.issueId ||
      ""
    );
  };

  componentDidMount() {
    const issueId = this.state.issueId || this.getIssueIdFromUrl();
    if (issueId && issueId !== this.state.issueId) {
      this.setState({ issueId }, () => {
        this.fetchIssueDetail();
        this.fetchComments();
      });
    } else {
      this.fetchIssueDetail();
      this.fetchComments();
    }
    this.fetchOperationsTeam();
    this.fetchPriorities();
  }

  fetchOperationsTeam = () => {
    this.setState({ loadingUsers: true });
    const apiCall = this.props.api?.apiGetOperationTeamList || window.app?.props?.api?.apiGetOperationTeamList;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.setState({ users: res.data, loadingUsers: false });
        } else {
          this.setState({ loadingUsers: false });
        }
      })
      .catch((err) => {
        console.error('Error fetching operations team:', err);
        this.setState({ loadingUsers: false });
      });
  };

  fetchPriorities = () => {
    this.setState({ loadingPriorities: true });
    const apiCall = this.props.api?.apiGetIssuePriorities || window.app?.props?.api?.apiGetIssuePriorities;
    if (!apiCall) return;

    apiCall()
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          this.setState({ priorities: res.data, loadingPriorities: false });
        } else {
          this.setState({ loadingPriorities: false });
        }
      })
      .catch((err) => {
        console.error('Error fetching priorities:', err);
        this.setState({ loadingPriorities: false });
      });
  };

  componentDidUpdate(prevProps) {
    const currentId = this.getIssueIdFromUrl();
    if (currentId && currentId !== this.state.issueId) {
      this.setState({ issueId: currentId }, () => {
        this.fetchIssueDetail();
        this.fetchComments();
      });
    }
  }

  formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  processIssueDetail = (res) => {
    if (!res) {
      this.setState({ loading: false });
      return false;
    }

    let issue = null;
    if (res.data && typeof res.data === "object" && !Array.isArray(res.data)) {
      if (res.data.data && typeof res.data.data === "object" && !Array.isArray(res.data.data)) {
        issue = res.data.data;
      } else {
        issue = res.data;
      }
    } else if (Array.isArray(res.data) && res.data[0]) {
      issue = res.data[0];
    } else if (res.issue && typeof res.issue === "object") {
      issue = res.issue;
    } else if (res.issueId || res._id || res.description) {
      issue = res;
    }

    if (issue && typeof issue === "object") {
      console.log("Issue detail loaded from get by id response. Status:", issue.status);
      let initialAssignTo = "Unassigned";
      if (issue.assignedTo) {
        if (typeof issue.assignedTo === "object") {
          initialAssignTo =
            issue.assignedTo.profile_id ||
            issue.assignedTo._id ||
            issue.assignedTo.id ||
            "Unassigned";
        } else if (typeof issue.assignedTo === "string" && issue.assignedTo !== "N/A") {
          initialAssignTo = issue.assignedTo;
        }
      }

      const initialPriority = issue.issuePriorityId || undefined;
      const initialEstimatedEndDate = issue.estimatedEndDate || null;
      const initialStatus = issue.status || undefined;

      this.setState({
        issueDetail: issue,
        updatePriority: initialPriority,
        updateEstimatedEndDate: initialEstimatedEndDate,
        updateStatus: initialStatus,
        updateAssignTo: initialAssignTo,
        initialPriority,
        initialEstimatedEndDate,
        initialStatus,
        initialAssignTo,
        loading: false,
      });
      return true;
    }
    this.setState({ loading: false });
    return false;
  };

  fetchIssueDetail = () => {
    const issueId = this.state.issueId || this.getIssueIdFromUrl();
    if (!issueId) return;

    this.setState({ loading: true, issueId });

    const apiCall = this.props.api?.apiGetIssueDetail || window.app?.props?.api?.apiGetIssueDetail;
    if (!apiCall) return;

    apiCall({}, { issueId })
      .then((res) => {
        console.log("fetchIssueDetail response:", res);
        this.processIssueDetail(res);
      })
      .catch((err) => {
        console.error("Direct fetch issue detail error:", err);
        this.setState({ loading: false });
      });
  };



  hasOperationsChanges = () => {
    const {
      updateAssignTo,
      initialAssignTo,
      updatePriority,
      initialPriority,
      updateStatus,
      initialStatus,
    } = this.state;

    const assignChanged =
      String(updateAssignTo || "Unassigned") !== String(initialAssignTo || "Unassigned");
    const priorityChanged =
      String(updatePriority || "") !== String(initialPriority || "");
    const statusChanged =
      String(updateStatus || "").trim() !== String(initialStatus || "").trim();

    return assignChanged || priorityChanged || statusChanged;
  };

  handleUpdateIssue = () => {
    const { issueId, updateAssignTo, updatePriority, updateStatus, updateEstimatedEndDate } = this.state;
    if (!issueId) return;

    if (!this.hasOperationsChanges()) {
      message.info("No changes to update");
      return;
    }

    this.setState({ updatingIssue: true });

    const payload = {};
    if (updateAssignTo && updateAssignTo !== "Unassigned") payload.assignedTo = updateAssignTo;
    if (updatePriority) payload.issuePriorityId = updatePriority;
    if (updateStatus) payload.status = updateStatus;

    const apiCall = this.props.api?.apiUpdateIssue || window.app?.props?.api?.apiUpdateIssue;
    if (!apiCall) {
      this.setState({ updatingIssue: false });
      return;
    }

    apiCall(payload, { issueId })
      .then((res) => {
        this.setState({ updatingIssue: false });
        if (res.error) {
          message.error(res.message || "Failed to update issue");
        } else {
          message.success("Issue updated successfully");
          this.setState({
            initialAssignTo: updateAssignTo,
            initialPriority: updatePriority,
            initialStatus: updateStatus,
          });
          this.fetchIssueDetail();
          this.fetchComments();
        }
      })
      .catch((err) => {
        this.setState({ updatingIssue: false });
        message.error("Failed to update issue");
        console.error("Update issue error:", err);
      });
  };

  processComments = (res) => {
    let list = [];
    if (res && res.data) {
      list = Array.isArray(res.data) ? res.data : (Array.isArray(res.data.data) ? res.data.data : []);
    } else if (Array.isArray(res)) {
      list = res;
    } else if (res && Array.isArray(res.comments)) {
      list = res.comments;
    }

    if (Array.isArray(list) && list.length > 0) {
      const formatted = list.map((c) => {
        const author =
          (Array.isArray(c.createdByData) ? c.createdByData[0]?.name : c.createdByData?.name) ||
          (Array.isArray(c.raisedByData) ? c.raisedByData[0]?.name : c.raisedByData?.name) ||
          (typeof c.createdBy === "object" ? c.createdBy?.name : null) ||
          c.author ||
          c.userName ||
          "User";

        return {
          author,
          action: c.comment || c.message || c.action || "",
          timestamp: this.formatDate(c.createdAt || c.timestamp),
        };
      });
      this.setState({ timeline: formatted });
      return true;
    }
    return false;
  };

  fetchComments = () => {
    const issueId = this.state.issueId || this.getIssueIdFromUrl();
    if (!issueId) return;

    const apiCall = this.props.api?.apiGetIssueComments || window.app?.props?.api?.apiGetIssueComments;
    if (!apiCall) return;

    apiCall({}, { issueId })
      .then((res) => {
        this.processComments(res);
      })
      .catch((err) => {
        console.error("Direct fetch comments error:", err);
      });
  };

  handlePostComment = () => {
    if (!this.state.comment.trim()) return;
    const { issueId, comment, issueDetail } = this.state;
    const schoolId =
      issueDetail?.schoolId ||
      issueDetail?.school?.school_id ||
      this.props.store?.school_id ||
      localStorage.getItem("school_id") ||
      "";

    this.setState({ submittingComment: true });
    const payload = {
      schoolId,
      issueId,
      comment: comment.trim(),
    };

    const apiCall = this.props.api?.apiAddIssueComment || window.app?.props?.api?.apiAddIssueComment;
    if (!apiCall) return;

    apiCall(payload)
      .then(() => {
        this.setState({ comment: "", submittingComment: false });
        message.success("Comment posted");
        this.fetchComments();
      })
      .catch((err) => {
        this.setState({ submittingComment: false });
        message.error("Failed to post comment");
        console.error("Comment POST error:", err);
      });
  };

  render() {
    const { issueId, mode, issueDetail } = this.state;
    const issue = issueDetail || {};

    const catName =
      issue.issueCategory?.name ||
      issue.issueCategoryData?.name ||
      issue.categoryName ||
      issue.category ||
      "Civil / Structural";

    const schoolName =
      issue.school?.school_name ||
      issue.schoolData?.school_name ||
      issue.schoolName ||
      issue.school ||
      "ABCD School";

    const title = `${catName} - ${schoolName}`;

    const role =
      localStorage.getItem("currentAdminRole") ||
      window.store?.getState()?.root?.user?.role;
    const isCoordinator = role === "SCHOOL_COORDINATOR";
    const isOperation = !isCoordinator;
    const targetLink = isCoordinator
      ? "/schoolinframaintenancetracker"
      : "/schoolinframaintenancetracker/maintenancequeue";

    const displayIssueId = issue.issueId || issueId || "SIM-007";
    const actionLabel = mode === "edit" ? "Edit" : "View";

    const customBreadcrumb = (
      <div className="breadcrumb d-flex align-items-center gap-2 mb-0" style={{ fontSize: "14px" }}>
        <Link to={targetLink} className="text-secondary text-decoration-none">
          School Infra Maintenance Issues Tracker
        </Link>
        <span className="text-muted">|</span>
        <span style={{ color: "#fca000", fontWeight: "600" }}>
          {actionLabel} {displayIssueId}
        </span>
      </div>
    );

    const description =
      issue.description ||
      "Wi-Fi has been down since morning assembly; smart boards can't load content.";

    const createdByName =
      (Array.isArray(issue.createdByData) ? issue.createdByData[0]?.name : issue.createdByData?.name) ||
      (typeof issue.createdBy === "object" ? issue.createdBy?.name : null);

    const reportedByName =
      (Array.isArray(issue.raisedByData) ? issue.raisedByData[0]?.name : issue.raisedByData?.name) ||
      (typeof issue.raisedBy === "object" ? issue.raisedBy?.name : null) ||
      (issue.raisedBy && typeof issue.raisedBy === "string" && issue.raisedBy.length < 25 && !issue.raisedBy.match(/^[0-9a-z]{15,}$/i) ? issue.raisedBy : null);

    const reportedBy =
      reportedByName ||
      createdByName ||
      "Priya Nair (educator)";

    const raisedOn = this.formatDate(issue.createdAt || issue.created_at || issue.raisedOn) !== "-"
      ? this.formatDate(issue.createdAt || issue.created_at || issue.raisedOn)
      : "15 Aug 2026, 10:41 am";

    const ownerDisplay =
      createdByName ||
      issue.assignedToData?.name ||
      (typeof issue.assignedTo === "object" ? issue.assignedTo?.name : null) ||
      (issue.assignedTo && issue.assignedTo !== "N/A" && typeof issue.assignedTo === "string" && issue.assignedTo.length < 25 ? issue.assignedTo : null) ||
      "Unassigned";

    // 1. Map priority directly from get by id response (only show if present in API)
    const rawPriorityVal = typeof issue.priority === "string" ? issue.priority : (issue.issuePriorityIdData?.name || "");
    const safePriorityStr = String(rawPriorityVal || "").trim();
    const rawPriority = safePriorityStr.toUpperCase().replace(/[\s-_]/g, "");
    let priorityDisplay = safePriorityStr || null;
    let priorityClass = "";

    if (rawPriority === "P0" || rawPriority.includes("CRITICAL")) {
      priorityClass = "severity-critical";
    } else if (rawPriority === "P1" || rawPriority.includes("HIGH")) {
      priorityClass = "severity-high";
    } else if (rawPriority === "P2" || rawPriority.includes("MEDIUM")) {
      priorityClass = "severity-medium";
    } else if (safePriorityStr) {
      priorityClass = `severity-${rawPriority.toLowerCase()}`;
    }

    // 2. Map status directly from get by id response
    const rawStatusVal =
      typeof issue.status === "string"
        ? issue.status
        : (typeof issue.status === "object" && issue.status?.name ? issue.status.name : (issue.status ? String(issue.status) : ""));
    const safeStatusStr = String(rawStatusVal || "Open").trim();
    const rawStatus = safeStatusStr.toUpperCase().replace(/[\s-_]/g, "");
    let statusDisplay = "Open";
    let statusClass = "status-open";

    if (rawStatus === "OPEN") {
      statusDisplay = "Open";
      statusClass = "status-open";
    } else if (rawStatus.includes("PROGRESS")) {
      statusDisplay = "In Progress";
      statusClass = "status-inprogress";
    } else if (rawStatus.includes("HOLD")) {
      statusDisplay = "On Hold";
      statusClass = "status-onhold";
    } else if (rawStatus.includes("RESOLV")) {
      statusDisplay = "Resolved";
      statusClass = "status-resolved";
    } else if (rawStatus.includes("CLOSE")) {
      statusDisplay = "Closed";
      statusClass = "status-closed";
    } else if (rawStatus.includes("CANCEL")) {
      statusDisplay = "Cancelled";
      statusClass = "status-cancelled";
    } else if (safeStatusStr) {
      statusDisplay = safeStatusStr.charAt(0).toUpperCase() + safeStatusStr.slice(1).toLowerCase();
      statusClass = `status-${rawStatus.toLowerCase()}`;
    }

    // 3. SLA Breached
    const showOnlySLABreached = issue.slaBreached === true || issue.showOnlySLABreached === true || issue.sla === true;

    // Activity timeline items
    const timelineItems = this.state.timeline;

    return (
      <LayoutWrapper title={title} customBreadcrumb={customBreadcrumb} backlink={targetLink}>
        <div className="edit-maintenance mt-3">
          {/* Status Badges Row at Top */}
          <div className="d-flex align-items-center gap-3 mb-4">
            {priorityDisplay && (
              <span className={`badge-severity ${priorityClass}`}>
                {priorityDisplay}
              </span>
            )}
            <span className={`badge-status-pill ${statusClass}`}>{statusDisplay}</span>
            {showOnlySLABreached && (
              <span className="text-danger fw-bold d-inline-flex align-items-center gap-1" style={{ fontSize: "13px" }}>
                <i className="la la-exclamation-triangle"></i> Breaching response window
              </span>
            )}
          </div>

          {/* Description Card */}
          <div className="details-card">
            <h4>Description</h4>
            <div className="description-text">{description}</div>
            <div className="details-row">
              <div className="detail-item">
                <span className="label">REPORTED BY</span>
                <span className="value">{reportedBy}</span>
              </div>
              <div className="detail-item">
                <span className="label">RAISED</span>
                <span className="value">{raisedOn}</span>
              </div>
              <div className="detail-item">
                <span className="label">OWNER</span>
                <span className="value">{ownerDisplay}</span>
              </div>
            </div>
          </div>

          {/* Operations Actions Card */}
          {isOperation && (
            <div className="details-card mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Operations actions</h4>
                {this.state.updatingIssue ? (
                  <i className="la la-spinner la-spin" style={{ color: '#FE8D01', fontSize: '24px' }}></i>
                ) : (
                  this.state.mode !== 'view' && (
                    <i
                      className="la la-bookmark"
                      style={{
                        color: this.hasOperationsChanges() ? '#FE8D01' : '#ccc',
                        fontSize: '24px',
                        cursor: this.hasOperationsChanges() ? 'pointer' : 'not-allowed',
                      }}
                      title={this.hasOperationsChanges() ? "Save" : "No changes to save"}
                      onClick={this.handleUpdateIssue}
                    ></i>
                  )
                )}
              </div>
              <Form layout="vertical">
                <div className="row g-3 mt-1">
                  <div className="col-md-3">
                    <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '13px' }}>Assign to</span>}>
                      <Select
                        placeholder="Select name"
                        value={this.state.updateAssignTo}
                        onChange={(val) => this.setState({ updateAssignTo: val })}
                        style={{ width: '100%' }}
                        size="large"
                        loading={this.state.loadingUsers}
                        showSearch
                        optionFilterProp="children"
                        disabled={this.state.mode === 'view'}
                      >
                        <Option value="Unassigned">Unassigned</Option>
                        {this.state.users.map(u => <Option key={u.profile_id} value={u.profile_id}>{u.name}</Option>)}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-md-3">
                    <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '13px' }}>Priority *</span>}>
                      <Select
                        placeholder="Select priority"
                        value={this.state.updatePriority}
                        onChange={(val) => {
                          const selectedPriority = this.state.priorities.find(p => p.issuePriorityId === val);
                          let newEndDate = this.state.updateEstimatedEndDate;
                          if (selectedPriority && selectedPriority.days) {
                            const moment = window.moment || require('moment');
                            newEndDate = moment().add(selectedPriority.days, 'days').format('YYYY-MM-DD');
                          }
                          this.setState({ updatePriority: val, updateEstimatedEndDate: newEndDate });
                        }}
                        style={{ width: '100%' }}
                        size="large"
                        loading={this.state.loadingPriorities}
                        showSearch
                        optionFilterProp="children"
                        disabled={this.state.mode === 'view'}
                      >
                        {this.state.priorities.map(p => <Option key={p.issuePriorityId} value={p.issuePriorityId}>{p.name}</Option>)}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-md-3">
                    <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '13px' }}>Estimated End Date *</span>}>
                      <Input
                        disabled
                        value={this.state.updateEstimatedEndDate ? this.formatDate(this.state.updateEstimatedEndDate) : "Not Set"}
                        style={{ backgroundColor: '#e9ecef', color: '#6c757d', height: '40px', borderRadius: '6px' }}
                      />
                    </Form.Item>
                  </div>
                  <div className="col-md-3">
                    <Form.Item label={<span className="fw-bold text-secondary" style={{ fontSize: '13px' }}>Status *</span>}>
                      <Select
                        placeholder="Select status"
                        value={this.state.updateStatus}
                        onChange={(val) => this.setState({ updateStatus: val })}
                        style={{ width: '100%' }}
                        size="large"
                        disabled={this.state.mode === 'view'}
                      >
                        <Option value={ISSUE_STATUS.OPEN}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.OPEN]}</Option>
                        <Option value={ISSUE_STATUS.INPROGRESS}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.INPROGRESS]}</Option>
                        <Option value={ISSUE_STATUS.ONHOLD}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.ONHOLD]}</Option>
                        <Option value={ISSUE_STATUS.RESOLVED}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.RESOLVED]}</Option>
                        <Option value={ISSUE_STATUS.CLOSED}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.CLOSED]}</Option>
                        <Option value={ISSUE_STATUS.CANCELLED}>{ISSUE_STATUS_LABELS[ISSUE_STATUS.CANCELLED]}</Option>
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          )}

          {/* Activity Card */}
          <div className="activity-card">
            <h4>Activity</h4>
            <div className="timeline">
              {timelineItems.length > 0 ? (
                timelineItems.map((item, idx) => (
                  <div className="timeline-item" key={idx}>
                    <div className="action-row">
                      <span className="timeline-dot"></span>
                      <span>
                        <strong>{item.author}</strong> — {item.action}
                      </span>
                    </div>
                    <div className="time-text">{item.timestamp}</div>
                  </div>
                ))
              ) : (
                <div className="text-center text-muted" style={{ padding: '20px 0' }}>
                  No comment found
                </div>
              )}
            </div>

            {this.state.mode !== 'view' && (
              <div className="comment-box">
                <textarea
                  placeholder="Add a comment..."
                  value={this.state.comment}
                  onChange={(e) => this.setState({ comment: e.target.value })}
                ></textarea>
                <div className="post-btn-wrapper">
                  <button
                    className="btn-post"
                    disabled={!this.state.comment.trim() || this.state.submittingComment}
                    onClick={this.handlePostComment}
                    style={{
                      opacity: this.state.comment.trim() ? 1 : 0.6,
                      cursor: this.state.comment.trim() ? "pointer" : "not-allowed",
                    }}
                  >
                    {this.state.submittingComment ? "Posting..." : "Post comment"}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </LayoutWrapper>
    );
  }
}

export default connect(EditMaintenanceQueue);
